import React, { useState } from "react";
import {
  makeStyles,
  Grid,
  List,
  ListItem,
  Typography,
  Box,
  AppBar,
  Tabs,
  Tab,
  Paper,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { useSpring, animated } from "react-spring";
import VideoSlider from "../../../../Sliders/VideoSlider";
import VideoSlickSlider from "../../../../Sliders/VideoSlickSlider";

const useStyles = makeStyles((theme) => ({
  topContainer: {
    [theme.breakpoints.down("md")]: {
      paddingTop: 16,
    },
  },
}));

interface ThreeThirdVideoProps {
  children: React.ReactNode | null | string | undefined;
}

function ThreeThirdVideo() {
  const classes = useStyles();

  const [{ sValue, brightValue, opacityValue, colorValue }, set] = useSpring(
    () => ({
      sValue: 1,
      brightValue: 0.4,
      opacityValue: 1,
      colorValue: "#e77842",
    })
  );
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  // const [value, setValue] = useState(0);
  // const [videoTitle, setVideoTitle] = useState<any>(null);
  // const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
  //   setValue(newValue);
  // };

  return (
    <Grid
      xs={12}
      item
      container
      justify={"center"}
      className={classes.topContainer}
    >
      <Paper
        elevation={0}
        component={animated.article}
        style={{
          width: "100%",
          zIndex: 0,
          overflow: "hidden",
          position: "relative",

          willChange: "transform",
          minHeight: !matches ? 480 : 193,
          maxHeight: !matches ? 480 : 193,
          // padding: "1rem 2rem 2rem 2rem",
          // backgroundImage:
          //   "linear-gradient(45deg,var(--gradient-orange-start),var(--gradient-orange-end))",
          borderRadius: 40,
          border: "1px solid #dadce0",
          // margin: "15px 8px 15px 15px",
          margin: 15,
          boxSizing: "border-box",
          // transform: sValue.interpolate((sValue) => `scale(${sValue}`),
        }}
        // onMouseEnter={() =>
        //   set({ sValue: 1.03, brightValue: 1, opacityValue: 0 })
        // }
        // onMouseLeave={() =>
        //   set({ sValue: 1, brightValue: 0.4, opacityValue: 1 })
        // }
      >
         <VideoSlider  />
        {/* <VideoSlickSlider /> */}
        {/* <Grid
          xs={12}
          item
          container
          justify="center"
          alignItems={"center"}
          style={{ height: "15%" }}
        >
          <Grid
            xs={4}
            item
            container
            style={{
              paddingLeft: 48,
              fontFamily: "Noto Sans Kr",
              fontWeight: 700,
              fontSize: 23,
              paddingTop: 8,
              paddingBottom: 8,
              letterSpacing: 8,
            }}
          >
            웹툰
          </Grid>
          <Grid
            xs={8}
            item
            container
            style={{
              fontFamily: "Noto Sans Kr",
              fontSize: 16,
              lineHeight: 1.334,
              paddingTop: 2,
              fontWeight: 500,
              letterSpacing: 0,
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflowWrap: "normal",
              overflow: "hidden",
            }}
          >
            {videoTitle}
          </Grid>
        </Grid> */}
       
      </Paper>
    </Grid>
  );
}

// export default MainContainer;
export default ThreeThirdVideo;
